// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"d37beb20","239":"f9af1e84","455":"a174f6e0","762":"d7e96b06"}[chunkId] + ".chunk.js";
};